<template>
  <div>
    <view-table
        ref="viewTable"
        :limits="limits"
        :columns-property="columnsProperty"
        :filter="filter"
        module="basic"
        url="replacementBills"
        @reset="resetHandle"
        @delete="deleteHandle"
        @select="selectHandle"
        @addOrEdit="addEditHandle">
      <template slot="otherBtn">
        <el-button
            type="primary"
            :loading="exportLoading"
            @click="exportExcel()">
          导出
        </el-button>
        <el-button
            type="primary"
            :loading="exportLoading"
            @click="exportExcel1()">
          导出审批节点
        </el-button>
        <el-button :disabled="selection.length!==1"
                   :loading="printLoading"
                   type="primary"
                   @click="printBill()">打印</el-button>
      </template>
      <template slot="adSearch">
        <el-form :inline="true" :model="filter" @keyup.enter.native="loadData(1)">
          <el-form-item label="单号">
            <el-input v-model.trim="filter.billNo" placeholder="请输入" clearable/>
          </el-form-item>
          <el-form-item label="销售订单号">
            <el-input v-model.trim="filter.salesOrderNo" placeholder="请输入" clearable/>
          </el-form-item>
          <el-form-item label="状态">
            <!--            <el-select v-model="filter.statusName" placeholder="请选择" clearable>-->
            <!--              <el-option label="草稿" value="草稿"/>-->
            <!--              <el-option label="业务经理审核" value="业务经理审核"/>-->
            <!--              <el-option label="总经理审核" value="总经理审核"/>-->
            <!--              <el-option label="品质审核" value="品质审核"/>-->
            <!--              <el-option label="技术" value="技术"/>-->
            <!--              <el-option label="上海生产" value="上海生产"/>-->
            <!--              <el-option label="江苏电阻生产" value="江苏电阻生产"/>-->
            <!--              <el-option label="江苏电抗生产" value="江苏电抗生产"/>-->
            <!--              <el-option label="物流" value="物流"/>-->
            <!--              <el-option label="业务南方区" value="业务南方区"/>-->
            <!--              <el-option label="业务北方区" value="业务北方区"/>-->
            <!--              <el-option label="品质" value="品质"/>-->
            <!--              <el-option label="采购" value="采购"/>-->
            <!--              <el-option label="江苏钣金生产" value="江苏钣金生产"/>-->
            <!--              <el-option label="工艺部" value="工艺部"/>-->
            <!--              <el-option label="品质复核" value="品质复核"/>-->
            <!--              <el-option label="总经理复核" value="总经理复核"/>-->
            <!--              <el-option label="通过" value="通过"/>-->
            <!--            </el-select>-->
            <el-select
                v-model="biddingStage1"
                :popper-append-to-body="false"
                class="biddingStageSty"
                multiple
                clearable
                placeholder="请选择"
                @change="handleSelect1">
              <el-option v-for="item in statusOptions" :key="item.value" :label="item.name" :value="item.value"/>
            </el-select>
          </el-form-item>
          <el-form-item label="责任部门">
            <el-select
                v-model="biddingStage"
                :popper-append-to-body="false"
                class="biddingStageSty"
                multiple
                clearable
                placeholder="请选择"
                @change="handleSelect">
              <el-option v-for="item in options" :key="item.value" :label="item.name" :value="item.value"/>
            </el-select>
          </el-form-item>
          <el-form-item label="客户">
            <el-input v-model.trim="filter.customerName" placeholder="请输入" clearable/>
          </el-form-item>
          <el-form-item label="物料编号">
            <el-input v-model.trim="filter.materialNo" placeholder="请输入" clearable/>
          </el-form-item>
          <el-form-item label="物料名称">
            <el-input v-model.trim="filter.materialName" placeholder="请输入" clearable/>
          </el-form-item>
          <el-form-item label="规格型号">
            <el-input v-model.trim="filter.specification" placeholder="请输入" clearable/>
          </el-form-item>
          <el-form-item label="制单人">
            <el-input v-model.trim="filter.creatorName" placeholder="请输入" clearable/>
          </el-form-item>
          <el-form-item label="制单日期">
            <el-date-picker
                v-model="createDateRange"
                type="daterange"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                value-format="yyyy-MM-dd"
                @change="dateRangeChange('createDateRange', 'createTimeBegin', 'createTimeEnd')"/>
          </el-form-item>
        </el-form>
      </template>
      <template slot="actionBtn" slot-scope="scope">
        <el-button
            v-if="limits.addAuth"
            type="primary"
            :disabled="scope.row.status !== 0"
            @click="submitHandle(scope.row)">
          提交
        </el-button>
      </template>
    </view-table>
    <replacement-bill-edit ref="editPage" @save-success="loadData(1)"/>
    <workflow-detail ref="workflowDetail"/>
    <print-replacement-bill-modal ref="billPrint"/>
  </div>
</template>

<script>
import viewTable from "@/components/ViewTable.vue";
import ReplacementBillEdit from "@/views/csm/ReplacementBill/ReplacementBillEdit";
import workflowDetail from "@/views/workFlow/WorkflowDetail.vue";
import PrintReplacementBillModal from "./PrintReplacementBillModal";

export default {
  name: "ReplacementBillList",
  components: {
    viewTable,
    ReplacementBillEdit,
    workflowDetail,
    PrintReplacementBillModal,
  },
  data() {
    return {
      ids: [],
      selection: [],
      requireDateRange: [],
      createDateRange: [],
      exportLoading: false,
      printLoading:false,
      limits: {
        addAuth: this.$auth(605),
        delAuth: this.$auth(607),
        editAuth: this.$auth(606),
      },
      options: [
        {name: "技术", value: "技术"},
        {name: "上海生产", value: "上海生产"},
        {name: "江苏电阻生产", value: "江苏电阻生产"},
        {name: "江苏电抗生产", value: "江苏电抗生产"},
        {name: "物流", value: "物流"},
        {name: "业务南方区", value: "业务南方区"},
        {name: "业务北方区", value: "业务北方区"},
        {name: "品质", value: "品质"},
        {name: "采购", value: "采购"},
      ],
      statusOptions: [
        {name: "草稿", value: "草稿"},
        {name: "业务经理审核", value: "业务经理审核"},
        {name: "总经理审核", value: "总经理审核"},
        {name: "品质审核", value: "品质审核"},
        {name: "技术", value: "技术"},
        {name: "上海生产", value: "上海生产"},
        {name: "江苏电阻生产", value: "江苏电阻生产"},
        {name: "江苏电抗生产", value: "江苏电抗生产"},
        {name: "物流", value: "物流"},
        {name: "业务南方区", value: "业务南方区"},
        {name: "业务北方区", value: "业务北方区"},
        {name: "品质", value: "品质"},
        {name: "采购", value: "采购"},
        {name: "江苏钣金生产", value: "江苏钣金生产"},
        {name: "工艺部", value: "工艺部"},
        {name: "品质复核", value: "品质复核"},
        {name: "总经理复核", value: "总经理复核"},
        {name: "文控审核", value: "文控审核"},
        {name: "通过", value: "通过"},
      ],
      biddingStage1: [],
      biddingStage: [],
      filter: {
        billNo: "",
        statusName: "",
        customerName: "",
        materialNo: "",
        materialName: "",
        specification: "",
        saleOrderNo: "",
        departments: "",
        statusNames: "",
        factoryNo: "",
        problemAddress: "",
        createTimeBegin: "",
        createTimeEnd: "",
        creatorName: "",
      },
      columnsProperty: [
        {
          key: "billNo",
          align: "center",
          width: 140,
          render: (h, params) => {
            return h(
                "span",
                {
                  style: {
                    color: "#2d8cf0",
                    cursor: "pointer",
                  },
                  on: {
                    click: () => {
                      this.$refs.editPage.open(params.row.pkId, true);
                    },
                  },
                },
                params.row.billNo,
            );
          },
        },
        {
          key: "statusName",
          align: "center",
          render: (h, params) => {
            return h(
                "span",
                {
                  style: {
                    color: "#2d8cf0",
                    cursor: "pointer",
                  },
                  on: {
                    click: () => {
                      this.$refs.workflowDetail.open(params.row.pkId, 14);
                    },
                  },
                },
                params.row.statusName,
            );
          },
        },
        {
          key: "action",
          align: "center",
          width: 200,
          fixed: "right",
          slot: "action",
        },
      ],
    };
  },

  watch: {
    "filter.departments": {
      handler(val) {
        if (val) {
          this.biddingStage = [];
          this.options.map(item => {
            val.split(",").forEach((s) => {
              if (s == item.value) {
                this.biddingStage.push(item.value);
              }
            });
          });
        }
      },
    },
    "filter.statusNames": {
      handler(val) {
        if (val) {
          this.biddingStage1 = [];
          this.statusOptions.map(item => {
            val.split(",").forEach((s) => {
              if (s == item.value) {
                this.biddingStage1.push(item.value);
              }
            });
          });
        }
      },
    },
    "filter.createTimeBegin": {
      handler(newVal) {
        if (newVal) {
          this.createDateRange = [];
          this.createDateRange.push(this.filter.createTimeBegin);
          this.createDateRange.push(this.filter.createTimeEnd);
        }
      },
    },
  },
  methods: {
    loadData(pageNum) {
      this.$refs.viewTable.loadData(pageNum);
    },
    dateRangeChange(timeRange, timeStart, timeEnd) {
      if (this[timeRange]) {
        this.filter[timeStart] = this[timeRange][0];
        this.filter[timeEnd] = this[timeRange][1];
      } else {
        this.filter[timeStart] = "";
        this.filter[timeEnd] = "";
      }
    },
    addEditHandle(row) {
      if (row) {
        this.$refs.editPage.open(row.pkId, false);
      } else {
        this.$refs.editPage.open(0, false);
      }
    },
    submitHandle(row) {
      this.$confirm("确定提交吗?", "提示", {type: "warning"}).then(() => {
        this.$http.post("basic", "replacementBills/submit/" + row.pkId).then(() => {
          //发送通知
          this.$http.post("basic", "replacementBills/updateNotify/" + row.pkId).catch(() => {
          });

          this.loadData(1);
          this.$message.success("提交成功");
          this.selection = [];
        });
      });
    },
    selectHandle(selection) {
      this.ids = [];
      this.selection = selection;
      this.selection.forEach((item) => {
        this.ids.push(item.pkid);
      });
    },
    printBill() {
      this.$refs.billPrint.open(this.selection[0]);
    },
    exportExcel() {
      this.exportLoading = true;
      this.$http
          .exportFile("basic", "replacementBills/export", this.filter)
          .then(res => {
            console.log(res);
            let blob = new Blob([res.data]);
            let fileName = decodeURI(res.headers.filename);
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
              navigator.msSaveBlob(blob, fileName);
            } else {
              let a = document.createElement("a");
              a.href = URL.createObjectURL(blob);
              a.download = fileName;
              a.style.display = "none";
              document.body.appendChild(a);
              a.click();
              URL.revokeObjectURL(a.href);
              document.body.removeChild(a);
            }
            this.exportLoading = false;
          })
          .catch(() => {
            this.exportLoading = false;
          });
    },
    exportExcel1() {
      this.exportLoading = true;
      this.$http
          .exportFile("basic", "replacementBills/exportWf", this.filter)
          .then(res => {
            console.log(res);
            let blob = new Blob([res.data]);
            let fileName = decodeURI(res.headers.filename);
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
              navigator.msSaveBlob(blob, fileName);
            } else {
              let a = document.createElement("a");
              a.href = URL.createObjectURL(blob);
              a.download = fileName;
              a.style.display = "none";
              document.body.appendChild(a);
              a.click();
              URL.revokeObjectURL(a.href);
              document.body.removeChild(a);
            }
            this.exportLoading = false;
          })
          .catch(() => {
            this.exportLoading = false;
          });
    },

    resetHandle(filter) {
      this.filter = Object.assign(this.filter, filter);
    },

    handleSelect(value) {
      if (value.length) {
        this.biddingStage = value;
        this.filter.departments = value.join(",");
      } else {
        this.biddingStage = [];
        this.filter.departments = "";
      }
    },

    handleSelect1(value) {
      if (value.length) {
        this.biddingStage1 = value;
        this.filter.statusNames = value.join(",");
      } else {
        this.biddingStage1 = [];
        this.filter.statusNames = "";
      }
    },

    // 提交
    submit() {
      // const arr = this.selection.filter((item) => item.status !== 0);
      // if (arr.length) {
      //   this.$confirm("请选择未提交的订单", "错误", {
      //     type: "error",
      //     showCancelButton: false,
      //   });
      // } else {
      this.$confirm("确定审核吗?", "提示", {type: "warning"}).then(() => {
        this.$http.post("basic", "replacementBills/approve", this.ids).then(() => {
          this.loadData(1);
          // this.$message.success("审核成功");
          this.selection = [];
        });
      });
      // }
    },

    // 单个删除
    deleteHandle(row) {
      this.$http.delete("basic", "replacementBills", row.pkId).then((resp) => {
        if (resp.success) {
          this.loadData(1);
          this.$message.success("删除成功");
          this.selection = [];
        }
      });
    },

    // 批量删除
    deleteBatch() {
      const arr = this.selection.filter((item) => item.status !== 0);
      if (arr.length) {
        this.$confirm("请选择未提交状态的订单", "错误", {
          type: "error",
          showCancelButton: false,
        });
        return;
      }
      this.$confirm("确定删除吗?", "提示", {type: "warning"}).then(() => {
        this.$http.post("basic", "replacementBills/deleteBatch", this.ids).then((resp) => {
          if (resp.success) {
            this.loadData(1);
            this.$message.success("删除成功");
            this.selection = [];
          }
        });
      });
    },

    otherAuth(row) {
      if (row.status === 0 || row.status === 5) {
        return {
          editAuth: false,
          delAuth: false,
        };
      } else {
        return {
          editAuth: true,
          delAuth: true,
        };
      }
    },
  },
};
</script>

<style>

</style>